module.exports = __webpack_public_path__ + "Journal Regular.4aa2726360c96af3f23b.otf";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/fonts/Journal Regular.otf
// module id = ../../../../../src/fonts/Journal Regular.otf
// module chunks = styles